const getters = {
  portalUrl: (state) => state.app.portalUrl,
  idCode: (state) => state.app.idCode,
  loading: (state) => state.app.loading,
  mainDOMRect: (state) => state.app.mainDOMRect,
  projectName: (state) => state.app.projectName,
  windowTitle: (state) => state.app.windowTitle,
  sidebar: (state) => state.app.sidebar,
  tagWel: (state) => state.app.tagWel,
  language: (state) => state.app.language,
  visLanguage: (state) => state.app.visLanguage,
  themeColor: (state) => state.app.themeColor,
  imageBaseUrl: (state) => state.app.imageBaseUrl,
  menus: (state) => state.login.menus,
  routes: (state) => state.login.routes,
  access_token: (state) => state.login.access_token,
  refresh_token: (state) => state.login.refresh_token,
  defaultUserPhoto: (state) => state.app.defaultUserPhoto,
  tenantInfo: (state) => state.login.tenantInfo,
  tenantConfig: (state) => state.login.tenantConfig,
  user: (state) => state.login.userInfo,
  config: (state) => state.login.archivesConfig
}
export default getters



// WEBPACK FOOTER //
// ./src/store/getters.js